<template>
    <v-layout fill-height fluid grid-list-xl>
        <v-flex xs12 md12>
            <v-form>
                <v-tabs vertical v-model="tabs" flat color="#FAFAFA">
                    <v-tab href="#informacoes_artisticas">Informações Profissionais</v-tab>
                    <v-tab href="#informacoes_pessoais">Informações Pessoais</v-tab>

                    <v-tabs-items v-model="tabs" class="white elevation-0">
                        <v-tab-item :key="0" :value="'informacoes_artisticas'">
                            <compositor_form_profissional
                                :composer_data="composer"
                                @compositor_data="compositorData"
                            />
                        </v-tab-item>
                        <v-tab-item :key="1" :value="'informacoes_pessoais'">
                            <persons_form :personsdata="persons" @persons_data="personsData" />
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>
            </v-form>
        </v-flex>

        <modal_message
            :dialog_opened="modal_dialog.dialog_opened"
            :title="modal_dialog.title"
            :message="modal_dialog.message"
            :btn_1_text="modal_dialog.btn_1_text"
            :btn_2_text="modal_dialog.btn_2_text"
            @btn_1_clicked="modal_dialog.btn_1_evnt"
            @btn_2_clicked="modal_dialog.btn_1_evnt"
        />
    </v-layout>
</template>

<script>
import compositor_form_profissional from "./compositor_form_profissional";
import persons_form from "../persons/form_persons";
import CompositorService from "../../app/Rest/composer";
import modal_message from "../shared/modal_message";

var compositorService = null;

export default {
    components: {
        compositor_form_profissional,
        persons_form,
        modal_message
    },

    data() {
        return {
            tabs: null,
            composer: {},
            persons: [],
            modal_dialog: {
                dialog_opened: false,
                title: null,
                message: null,
                btn_1_text: null,
                btn_2_text: null,
                btn_1_evnt: function() {},
                btn_2_evnt: function() {}
            }
        };
    },

    props: {
        compositor_id: Number
    },

    //continuar daqui e passando as informações para os componentes
    created() {
        compositorService = CompositorService.build();

        if (!this.compositor_id) return;

        compositorService.getOne(this.compositor_id).then(e => {
            this.composer = e.items.composer;
            this.persons = e.items.persons;
        });
    },

    methods: {
        salvar() {
            if (this.persons.length) {
                this.composer.persons = this.persons;
            }

            console.log(this.composer);
            this.$store.dispatch("loading_full");
            compositorService
                .salvar(this.composer)
                .then(e => {
                    console.log("retorno", e);
                    if (e.items) {
                        this.persons = e.items.persons;
                        this.composer = e.items.composer;

                        this.modal_dialog.title = "Salvo com sucesso!";
                        this.modal_dialog.btn_1_text = "obrigado";
                        this.modal_dialog.btn_1_evnt = e => {
                            this.modal_dialog.dialog_opened = false;
                        };
                        this.modal_dialog.dialog_opened = true;
                    }
                })
                .finally(e => {
                    this.$store.dispatch("loading_full");
                });
        },
        /**
         * Retorno dos componentes
         */
        personsData(persons) {
            this.persons = persons;
        },
        compositorData(compositor) {
            this.composer = compositor;
        }
    }
};
</script>